import React from 'react'
import Footer from "../containers/Footer";
import MobileNavbar from "../containers/MobileNavbar";
import TopNav from "../containers/TopNav/TopNav";
import { Callout } from "@blueprintjs/core";
import { navigate } from "../store/navigation/operations";
import { Translate, I18n } from "react-redux-i18n";
import { useDispatch } from 'react-redux';

const RentalSuccessMessage = () => {
    const dispatch = useDispatch();

    const goToProducts = () => {
        dispatch(navigate(`/rentals`));
    }

    return (
        <section className="gray-bg">
            <div className="main-container">
                <div className="prylpool-products-container">
                    <Callout title={I18n.t('rental.transaction_successful')} intent="success" className="rent-success">
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%;" }}>
                            <a href="https://apps.apple.com/app/ihopa/id1569011311" class="bp5-button bp5-intent-success bp5-outlined">
                                {I18n.t('rental.download_on_app_store')}
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=com.ihopamobileapp" class="bp5-button bp5-intent-success bp5-outlined">
                                {I18n.t('rental.download_on_google_play')}
                            </a>
                        </div>
                    </Callout>
                    <a href=' ' onClick={goToProducts} >
                        <strong>← &nbsp;<Translate value='prypool.back' /></strong>
                    </a>
                </div>
            </div>
        </section>
    )
}

export default function RentalSuccess() {
    return (
        <div className="app-wrapper has-mobile-navbar">
            <TopNav />
            <RentalSuccessMessage />
            <MobileNavbar />
            <Footer />
        </div>
    )
}
